<div>
  @if (
    otherParams?.checkBoxSelectionEnabled ||
    (otherParams?.paginationData && rows >= 10 && totalPages > 1)
  ) {
    <div class="d-flex justify-content-between align-items-center">
      <div>
        @if (otherParams?.checkBoxSelectionEnabled) {
          <div>
            <input
              class="form-check-input"
              type="checkbox"
              id="selectAllCheckBox"
              [checked]="allItemsSelected"
              (change)="selectDeselectGpsTrackRecords()"
            />
            <span
              class="text-primary fw-semibold ms-2 cursor-pointer"
              (click)="selectDeselectGpsTrackRecords()"
            >
              Select All
            </span>
          </div>
        }
      </div>
    </div>
  }

  <!-- table for desktop STARTS -->

  @if (appliedFilters?.length) {
    <div>
      <div class="d-flex align-items-center p-2 flex-wrap mb-lg-2">
        <span class="text-secondary d-none d-lg-inline">
          Results Filtered
        </span>
        @for (filter of appliedFilters; track filter; let first = $first) {
          <div>
            <div class="d-flex align-items-center p-2">
              <div
                role="button"
                class="py-1 px-2 hover"
                (click)="
                  filter?.datetimeObj && filter?.columnData
                    ? openRangePicker(filter?.columnData)
                    : null
                "
              >
                <span class="small">
                  {{ filter?.key | titlecase }}
                </span>
                <span class="fw-semibold text-white bg-primary p-1 rounded-1">
                  {{ filter?.value }}
                </span>
              </div>
              @if (
                !filter?.datetimeObj ||
                (filter?.datetimeObj && !filter?.columnData?.default && !first)
              ) {
                <span (click)="removeFilter(filter?.key)">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (otherParams?.paginationData && rows >= 10 && totalPages > 1) {
    <div class="mt-2">
      <gtapp-pagination-control
        [pageSize]="rows"
        [pageNum]="pageNum"
        [previous]="previousRows"
        [totalRows]="totalRows"
        [fixedRows]="otherParams?.paginationData?.fixedRows"
        (onChangePagination)="onChangePagination($event)"
      >
      </gtapp-pagination-control>
    </div>
  }

  <div [ngStyle]="tableStyle">
    <table class="table table-desktop">
      <thead>
        <tr>
          @if (otherParams?.checkBoxSelectionEnabled) {
            <th></th>
          }
          @for (indColumn of desktopTableDetails; track indColumn) {
            <th [ngStyle]="indColumn?.tableHeaderStyle">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ indColumn?.header }} </span>
                <div class="d-flex flex-row gap-2">
                  @if (
                    !indColumn?.openSearchBox &&
                    indColumn?.toggleFields &&
                    apiFiltering
                  ) {
                    <span (click)="toggleField(indColumn)">
                      <span>
                        <i class="fa-solid fa-left-right"></i>
                      </span>
                    </span>
                  }
                  @if (!indColumn?.openSearchBox && indColumn?.sortKey) {
                    <span (click)="sortField(indColumn)">
                      @if (
                        indColumn?.sortOrder === "asc" || !indColumn?.sortOrder
                      ) {
                        <span>
                          <i class="fa-solid fa-arrow-down-a-z"></i>
                        </span>
                      }
                      @if (indColumn?.sortOrder === "desc") {
                        <span>
                          <i class="fa-solid fa-arrow-down-z-a"></i>
                        </span>
                      }
                    </span>
                  }
                  @if (!indColumn?.openSearchBox && indColumn?.searchKey) {
                    <span (click)="indColumn.openSearchBox = true">
                      <i class="fa-solid fa-filter"></i>
                    </span>
                  }
                  @if (indColumn?.openSearchBox || indColumn?.opendropDownBox) {
                    <span
                      (click)="
                        indColumn.openSearchBox = false;
                        indColumn.opendropDownBox = false
                      "
                    >
                      <i class="fa fa-close"></i>
                    </span>
                  }
                  @if (!indColumn?.opendropDownBox && indColumn?.dropdownKey) {
                    <span (click)="indColumn.opendropDownBox = true">
                      <i class="fa-regular fa-rectangle-list"></i>
                    </span>
                  }
                  @if (indColumn?.dateRangeKey) {
                    <span (click)="openRangePicker(indColumn)">
                      <i class="fa fa-calendar"></i>
                    </span>
                  }
                </div>
              </div>
              @if (indColumn?.openSearchBox) {
                <div class="mb-1">
                  @if (indColumn?.autoComplete) {
                    <gtapp-auto-complete
                      [data]="autoCompleteSearchResultList"
                      placeHolder="Search  {{
                        indColumn | misc: 'getFilterHeader' | titlecase
                      }}"
                      [searchKeyword]="indColumn?.autoComplete"
                      [initialValue]="indColumn?.searchValue"
                      [itemTemplate]="autoCompleteTemplate"
                      [enableSearchCloseOption]="true"
                      (inputChanged)="
                        onAutoCompleteInputSearch($event, indColumn)
                      "
                      (selected)="onAutoCompleteItemSelect($event, indColumn)"
                      (submitted)="onAutoCompleteItemSelect($event, indColumn)"
                    >
                    </gtapp-auto-complete>
                    <ng-template #autoCompleteTemplate let-item>
                      <div>
                        {{ item?.full_name }}
                      </div>
                    </ng-template>
                  } @else {
                    <div class="input-group flex-nowrap">
                      <input
                        type="text"
                        [(ngModel)]="indColumn.searchValue"
                        placeholder="Search"
                        class="form-control w-75"
                        (keyup.enter)="
                          indColumn?.searchValue ? searchField(indColumn) : null
                        "
                      />
                      <span
                        class="input-group-text"
                        (click)="
                          indColumn?.searchValue ? searchField(indColumn) : null
                        "
                      >
                        <i class="fa-solid fa-filter"></i>
                      </span>
                    </div>
                  }
                </div>
              }
              @if (indColumn?.opendropDownBox) {
                <div class="form-floating">
                  <select
                    class="form-select"
                    placeholder="Select"
                    [(ngModel)]="selectedItem"
                    id="selectDropDown"
                    (change)="selectItem(selectedItem, indColumn)"
                  >
                    @for (status of indColumn?.dropDownList(); track status) {
                      <option [ngValue]="status" [disabled]="status?.disabled">
                        {{ status?.name }}
                      </option>
                    }
                  </select>
                  <label for="selectDropDown">Select</label>
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody class="align-middle">
        @for (indData of tableData; track indData; let i = $index) {
          <tr
            [ngStyle]="getTableRowStyle(indData, i)"
            (click)="onTableRowClick(indData, i)"
          >
            @if (otherParams?.checkBoxSelectionEnabled) {
              <td (click)="$event.stopImmediatePropagation()">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="indData?.checboxTicked"
                  (change)="onCheckBoxChange($event, indData)"
                />
              </td>
            }
            @for (
              indColumn of desktopTableDetails;
              track indColumn;
              let j = $index
            ) {
              <td
                [ngStyle]="
                  indColumn?.conditionalColumnStyle
                    ? indColumn?.conditionalColumnStyle(indData)
                    : indColumn?.tableColumnStyle
                "
              >
                <!-- rows where objects are datetime objects STARTS-->
                <!--style whole row either based on condition or common to all -->
                @if (indColumn?.datetimeObj == true) {
                  <div>
                    <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalPrefixStyle
                          ? indColumn?.conditionalPrefixStyle(indData)
                          : indColumn?.prefixStyle
                      "
                    >
                      <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                      {{
                        indColumn?.prefixNestedValue
                          ? indColumn?.prefixNestedValue(indData)
                          : indColumn?.prefix
                            ? indColumn?.prefix
                            : ""
                      }}
                    </span>
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                    <!-- main content which will be passed from the backend STARTS-->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalColumnDataStyle
                          ? indColumn?.conditionalColumnDataStyle(indData)
                          : indColumn?.columnDataStyle
                      "
                    >
                      {{
                        indColumn?.nestedValue
                          ? (indColumn?.nestedValue(indData)
                            | customDate
                              : indColumn?.dateTimeFormat || "d MMM y HH:mm")
                          : (indData[indColumn?.name]
                            | customDate
                              : indColumn?.dateTimeFormat || "d MMM y HH:mm")
                      }}
                    </span>
                    <!-- main content which will be passed from the backend ENDS-->
                    <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalSuffixStyle
                          ? indColumn?.conditionalSuffixStyle(indData)
                          : indColumn?.suffixStyle
                      "
                    >
                      {{
                        indColumn?.suffixNestedValue
                          ? indColumn?.suffixNestedValue(indData)
                          : indColumn?.suffix
                            ? indColumn?.suffix
                            : ""
                      }}
                    </span>
                    <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  </div>
                }
                <!-- rows where objects are datetime objects ENDS-->
                <!-- rows where objects are normal objects STARTS-->
                <!--style whole row either based on condition or common to all -->
                @if (indColumn?.imageObj === true) {
                  <div>
                    <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalPrefixStyle
                          ? indColumn?.conditionalPrefixStyle(indData)
                          : indColumn?.prefixStyle
                      "
                    >
                      <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                      {{
                        indColumn?.prefixNestedValue
                          ? indColumn?.prefixNestedValue(indData)
                          : indColumn?.prefix
                            ? indColumn?.prefix
                            : ""
                      }}
                    </span>
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                    <!-- main content which will be passed from the backend STARTS-->
                    @if (
                      indColumn?.mediaSrc
                        ? indColumn?.mediaSrc
                        : indColumn?.nestedValue
                          ? indColumn?.nestedValue(indData)
                          : indData?.[indColumn?.name]
                    ) {
                      <img
                        [ngStyle]="
                          indColumn?.conditionalImageStyle
                            ? indColumn?.conditionalImageStyle(indData)
                            : indColumn?.imageStyle
                        "
                        src="{{
                          indColumn.mediaSrc
                            ? indColumn?.mediaSrc
                            : indColumn?.nestedValue
                              ? indColumn?.nestedValue(indData)
                              : indData?.[indColumn?.name]
                        }}"
                      />
                    }
                    <!-- main content which will be passed from the backend ENDS-->
                    <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalSuffixStyle
                          ? indColumn?.conditionalSuffixStyle(indData)
                          : indColumn?.suffixStyle
                      "
                    >
                      {{
                        indColumn?.suffixNestedValue
                          ? indColumn?.suffixNestedValue(indData)
                          : indColumn?.suffix
                            ? indColumn?.suffix
                            : ""
                      }}
                    </span>
                    <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  </div>
                }
                <!-- rows where objects are IMAGE objects ENDS-->

                <!-- rows where objects are ICON objects STARTS-->
                @if (indColumn?.iconObj === true) {
                  <div>
                    <span
                      [ngStyle]="
                        indColumn?.conditionalColumnDataStyle
                          ? indColumn?.conditionalColumnDataStyle(indData)
                          : indColumn?.columnDataStyle
                      "
                    >
                      <i
                        [class]="
                          indColumn.iconClass
                            ? indColumn?.iconClass
                            : indColumn?.nestedValue
                              ? indColumn?.nestedValue(indData)
                              : indData?.[indColumn?.name]
                        "
                        [title]="
                          indColumn.iconTitle
                            ? indColumn?.iconTitle
                            : indColumn?.nestedValue
                              ? indColumn?.nestedValue(indData)
                              : indData?.[indColumn?.name]
                        "
                      ></i>
                    </span>
                  </div>
                }
                <!-- rows where objects are ICON objects ENDS-->

                <!-- rows where objects are normal objects STARTS-->
                @if (
                  !indColumn?.datetimeObj &&
                  !indColumn?.imageObj &&
                  !indColumn?.iconObj
                ) {
                  <div>
                    <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalPrefixStyle
                          ? indColumn?.conditionalPrefixStyle(indData)
                          : indColumn?.prefixStyle
                      "
                    >
                      <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                      {{
                        indColumn?.prefixNestedValue
                          ? indColumn?.prefixNestedValue(indData)
                          : indColumn?.prefix
                            ? indColumn?.prefix
                            : ""
                      }}
                    </span>
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                    <!-- main content which will be passed from the backend STARTS-->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalColumnDataStyle
                          ? indColumn?.conditionalColumnDataStyle(indData)
                          : indColumn?.columnDataStyle
                      "
                      class="gt-multi-line"
                    >
                      {{
                        indColumn.nestedValue
                          ? indColumn.nestedValue(indData)
                          : indData[indColumn.name] == "null" ||
                              indData[indColumn.name] == "undefined"
                            ? "N/A"
                            : indData[indColumn.name]
                      }}
                    </span>
                    <!-- main content which will be passed from the backend ENDS-->
                    <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    <span
                      [ngStyle]="
                        indColumn?.conditionalSuffixStyle
                          ? indColumn?.conditionalSuffixStyle(indData)
                          : indColumn?.suffixStyle
                      "
                    >
                      {{
                        indColumn?.suffixNestedValue
                          ? indColumn?.suffixNestedValue(indData)
                          : indColumn?.suffix
                            ? indColumn?.suffix
                            : ""
                      }}
                    </span>
                    <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  </div>
                }
                <!-- rows where objects are normal objects ENDS-->
                @if (tableActionIcons && indColumn?.showAction === true) {
                  <div class="table-icon-class text-secondary">
                    @for (actionIcon of tableActionIcons; track actionIcon) {
                      @if (
                        actionIcon?.condition
                          ? actionIcon.condition(indData)
                          : true
                      ) {
                        <span
                          class="mx-1"
                          (click)="
                            onActionClick(
                              indData,
                              actionIcon?.condition(indData)?.type,
                              i
                            );
                            $event.stopImmediatePropagation()
                          "
                        >
                          <i
                            [class]="actionIcon?.condition(indData)?.icon"
                            [title]="actionIcon?.condition(indData)?.title"
                          ></i>
                        </span>
                      }
                    }
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (tableData?.length == 0) {
    <div>
      <div class="alert" role="alert">No Records Found</div>
    </div>
  }
  <!-- table for desktop ENDS -->
  @if (otherParams?.paginationData) {
    <div class="mt-2">
      <gtapp-pagination-control
        [pageSize]="rows"
        [pageNum]="pageNum"
        [previous]="previousRows"
        [totalRows]="totalRows"
        [fixedRows]="otherParams?.paginationData?.fixedRows"
        (onChangePagination)="onChangePagination($event)"
      >
      </gtapp-pagination-control>
    </div>
  }
</div>
